import React from 'react';
import classNames from 'classnames';
import Styles from './table-row.less';

const baseClass = Styles.tr;

module.exports = React.createClass({
    displayName: 'TableRow',
    propTypes: {
        className: React.PropTypes.string,
        onClick: React.PropTypes.func,
        onHover: React.PropTypes.func,
        selectable: React.PropTypes.bool,
        selected: React.PropTypes.bool,
        model: React.PropTypes.object
    },
    getChildren() {
        return React.Children.toArray(this.props.children)
            .filter(React.isValidElement)
            .filter(child => child.type.displayName == 'TableColumn')
            .map((item, key) => React.cloneElement(item, {
                key: this.props.model.id + key,
                model: this.props.model
            }));
    },
    getClass() {
        return classNames(baseClass, this.props.className);
    },
    render: require('./table-row.rt')
});

//TODO: Add checkbox support
//TODO: Add sticky header through react

//TODO: Add if table's model is null


/** WEBPACK FOOTER **
 ** ./src/table/table-row/table-row.js
 **/